import React, { Component } from 'react';
import './css/Modal.css';
import { Scrollbars } from 'react-custom-scrollbars';
//import FX from './functions/functions';



class Modal extends Component {
  render(){
    var right_buttons;
    var left_buttons;
    if(this.props.buttons){
      right_buttons = this.props.buttons.map(btn => {
          if(btn.left !== true){
            var className = "";
            if (btn.className) {
              className = btn.className;
            }
            return <button className={className}  onClick={btn.action}>{btn.text}</button>
          }
          return '';
      });
      left_buttons = this.props.buttons.map(btn => {
          if(btn.left === true){
            var className = "";
            if (btn.className) {
              className = btn.className;
            }
            return <button className={className}  onClick={btn.action}>{btn.text}</button>
          }
          return '';
      });
    }
    var fs = "modalPanel ";
    if (this.props.fs){
      fs += 'fs';
    }
    var footer;
    if (right_buttons || left_buttons) {
      footer = (
                  <div className="footer">
                    <div className="foot_lt_btn">
                      {left_buttons}
                    </div>
                    <div className="foot_rt_btn">
                      {right_buttons}
                    </div>
                  </div>
               );
      fs += 'buttoned';
    }
    else {
      fs += " nofeet";
    }
    if(this.props.type !== "confirm") {
        return (<div className="modalShade" onClick={this.props.close} id="Modal">
              <div onClick={(e)=>{e.stopPropagation();}}  className={fs} >
                  <div className="title">
                      <div onClick={this.props.close} className="closeBtn"><i className="material-icons">close</i></div>
                      <h1>{this.props.title}</h1>
                  </div>
                  <div className="scroll-content">
                      <div className="body">
                        {this.props.sideBar}
                        <Scrollbars style={{ position: 'absolute', top:0, left: 0, right: 0, bottom: 0, padding: '20px', width: 'auto', height: 'auto'}}>
                          {this.props.children}
                        </Scrollbars>
                      </div>
                  </div>
                  {footer}
              </div>
          </div>);
    }
    else {
        fs += ' ' + this.props.type;

        var header;
        if(this.props.title){
            header = (
              <div className="title">
                  <div onClick={this.props.close} className="closeBtn"><i className="material-icons">close</i></div>
                  <h1>{this.props.title}</h1>
              </div>);
        }
        return (<div className="modalShade" onClick={this.props.close} id="Modal">
              <div onClick={(e)=>{e.stopPropagation();}}  className={fs} >
                  {header}
                  <div className="body">
                    {this.props.children}
                  </div>
                  {footer}
              </div>
          </div>);
    }
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/Modal.js